import React, { useState } from "react";
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, } from "@mui/material";
import { projectManageAxios as axios } from '../../utils/AxiosUtility';

export default function DeleteContact({ contactId, onContactDeleted }) {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDelete = () => {
    const endpoint = `/api/Onboarding/deleteContact/${contactId}`;

    axios
      .delete(endpoint)
      .then(() => {
        onContactDeleted();
        handleClose();
      })
      .catch((error) => {
        console.error(error);
        alert(error.response?.data || "Error deleting contact. Please try again.");
        handleClose();
      })
  };

  return (
    <div>
      <Button variant="outlined" color="error" onClick={handleOpen}>
        Delete
      </Button>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Delete Contact</DialogTitle>
        <DialogContent>
          Are you sure you want to delete this contact?
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleDelete} color="error">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
